class LocationVariable {
  constructor() {
    const data = arguments[0] || {};
    this.id = data.id || null;
    this.name = data.name || '';
    this.active = data.active || true;
    this.assigned_at = data.assigned_at || null;
  }
}

export default LocationVariable;
